import { render, staticRenderFns } from "./wasteproductionEdit.vue?vue&type=template&id=21401e15&"
import script from "./wasteproductionEdit.vue?vue&type=script&lang=js&"
export * from "./wasteproductionEdit.vue?vue&type=script&lang=js&"
import style0 from "./wasteproductionEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports